import { CleanSchema, get } from '../../../json-transform';

export const SearchFiltersSchema = new CleanSchema({
  age__gte: get('age[0]').asInt(),
  age__lt: get('age[1]').asInt(),
  apparent_age__gte: get('apparent_age[0]').asInt().ifNaN(undefined),
  apparent_age__lt: get('apparent_age[0]').asInt().ifNaN(undefined),
  apparent_gender: get('apparent_gender').asArrayOfInt().asArrayWithOptionalNull().ifEmpty(undefined),
  areas: get('areas').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  backpack_states: get('backpack_states').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  cities: get('cities').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  create_time__gte: get('create_time__gte[0]').asISOString(),
  create_time__lt: get('create_time__lt[0]').asISOString(),
  deepfake: get('deepfake').asArrayOfInt().asArrayWithOptionalNull().ifEmpty(undefined),
  districts: get('districts').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  emotions: get('emotions').asArrayOfInt().asArrayWithOptionalNull().ifEmpty(undefined),
  event_ids: get('event_ids').asArrayFromString().ifEmpty(undefined),
  event_id__gte: get('event_id__gte'),
  event_id__lt: get('event_id__lt'),
  external_ids: get('external_ids').asArrayFromString().ifEmpty(undefined),
  end_time__gte: get('end_time__gte[0]').asISOString(),
  end_time__lt: get('end_time__lt[0]').asISOString(),
  face_ids: get('face_ids').asArrayFromString().ifEmpty(undefined),
  gender: get('gender[0]').asInt(),
  geo_position: {
    origin_longitude: get('origin_longitude').asFloat().ifNaN(undefined),
    origin_latitude: get('origin_latitude').asFloat().ifNaN(undefined),
    longitude_delta: get('longitude_delta').asFloat().ifNaN(undefined),
    latitude_delta: get('latitude_delta').asFloat().ifNaN(undefined),
  },
  headwear_states: get('headwear_states').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  headwear_apparent_colors: get('headwear_apparent_colors').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  handler_ids: get('handler_ids').asArrayFromString().ifEmpty(undefined),
  house_numbers: get('house_numbers').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  liveness: get('liveness').asArrayOfInt().asArrayWithOptionalNull().ifEmpty(undefined),
  list_id: get('list_id')
    .as((v) => (typeof v === 'object' ? get().asOptionValue()(v) : v))
    .asString()
    .ifEmptyString(undefined),
  lower_garment_colors: get('lower_garment_colors').asArrayOfOptionValues().asArrayWithOptionalNull().ifEmpty(undefined),
  lower_garment_types: get('lower_garment_types').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  masks: get('masks').asArrayOfInt().asArrayWithOptionalNull().ifEmpty(undefined),
  origin: get('origin').ifEmpty('events'),
  stream_ids: get('stream_ids').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  streets: get('streets').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  sources: get('sources').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  shoes_apparent_colors: get('shoes_apparent_colors').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  sleeve_lengths: get('sleeve_lengths').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  top_similar_object_ids: get('top_similar_object_ids').asArrayFromString().ifEmpty(undefined),
  top_similar_object_similarity__lt: get('top_similar_object_similarity__lt').asFloat().toNormalizedPercent().ifNaN(undefined),
  top_similar_object_similarity__gte: get('top_similar_object_similarity__gte').asFloat().toNormalizedPercent().ifNaN(undefined),
  top_matching_candidates_label: get('top_matching_candidates_label').ifEmptyString(undefined),
  tags: get('tags').asArrayOfOptionValues().ifEmpty(undefined),
  track_ids: get('track_ids').asArrayFromString().asArrayWithOptionalNull().ifEmpty(undefined),
  upper_clothing_colors: get('upper_clothing_colors').asArrayOfOptionValues().asArrayWithOptionalNull().ifEmpty(undefined),
  user_data: get('user_data').ifEmptyString(undefined),
  attribute_ids: get('attribute_ids').asArrayFromString().ifEmpty(undefined),
});
